import React from "react";
import { Timestamp } from "components/common";
import { RiskScoreBadge } from "security-app/components/common";
const columnRenderers = {
  attributes: {
    message: {},
    scores: {
      staticWidth: 250,
      renderCell: (scores) => /* @__PURE__ */ React.createElement(RiskScoreBadge, { riskScore: (scores == null ? void 0 : scores.normalized_risk) || 0 })
    },
    timestamp: {
      staticWidth: 250,
      renderCell: (timestamp) => /* @__PURE__ */ React.createElement(Timestamp, { dateTime: timestamp })
    }
  }
};
export default columnRenderers;
